import { Component } from '@angular/core';

@Component({
  selector: 'def-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  date: string = new Date().toLocaleDateString();
  year: string = new Date().getFullYear().toString();
}
